 
// custome text typing animation method
export const lean_features: string[] = ['Autonomous Maintenance','Progressive Maintenance', 'Safety & Environment', 'KPI Management', 'Analytics', 'Performance Management', 'Loss Analysis','Overall Action Plan','Document Management', 'Analytical Tools','Audit Management','TDC Management'];

export const core_features: string[] = ['Dynamic Dashboard', 'O3 Administration', 'Production Order Management', 'Quality Management','Pest Control','Productivity Management','Manage Account','Advanced Analytics']


export function typing_animation() {
    let text_element: any = document.querySelector(".animated_text");
    let text_array: any = text_element?.innerHTML.split("");
    let text_array_slice: any = text_element?.innerHTML.split(" ");
    let text_len: any = text_array?.length;

    const word_len = text_array_slice?.map((word: any) => {
        return word.length;
    })
    let timings: any = {
        easing: `steps(${Number(word_len[0] + 1)}, end)`,
        delay: 2000,
        duration: 2000,
        fill: 'forwards'
    }

    let cursor_timings = {
        duration: 700,
        iterations: Infinity,
        easing: 'cubic-bezier(0,.26,.44,.93)'
    }

    document.querySelector(".text_cursor")?.animate([
        {
            opacity: 0
        },
        {
            opacity: 0, offset: 0.7
        },
        {
            opacity: 1
        }
    ], cursor_timings);

    if (text_array_slice?.length == 1) {
        timings.easing = `steps(${Number(word_len[0] === 0 ? 1 : word_len[0])}, end)`;

        let reveal_animation: any = document.querySelector(".text_hide")?.animate([
            { left: '0%' },
            { left: `${(100 / text_len) * (word_len[0])}%` }
        ], timings);

        document.querySelector(".text_cursor")?.animate([
            { left: '0%' },
            { left: `${(100 / text_len) * (word_len[0])}%` }
        ], timings);

        reveal_animation.onfinish = () => {
            setTimeout(() => {
                document.querySelector('.text_hide')?.animate([
                    {left: '0%'}
                ], {
                    duration: 2000,
                    easing: 'cubic-bezier(.73,0,.38,.88)'
                });
                document.querySelector('.text_cursor')?.animate([
                    {left: '0%'}
                ], {
                    duration: 2000,
                    easing: 'cubic-bezier(.73,0,.38,.88)'
                });
                typing_animation();
            }, 1000);
        }
    } else {
        document.querySelector(".text_hide")?.animate([
            { left: '0%' },
            { left: `${(100 / text_len) * (word_len[0] + 1)}%` }
        ], timings);

        document.querySelector(".text_cursor")?.animate([
            { left: '0%' },
            { left: `${(100 / text_len) * (word_len[0] + 1)}%` }
        ], timings);
    }


    for (let i = 1; i < text_array_slice.length; i++) {
        const single_word_len = word_len[i];

        if (i == 1) {
            var left_instance: any = (100 / text_len) * (word_len[i - 1] + 1);
        }

        let timings_2: any = {
            easing: `steps(${Number(single_word_len + 1)}, end)`,
            delay: (2 * (i + 1) + (2 * i)) * (1000),
            // delay: ((i*2)-1)*1000,
            duration: 2000,
            fill: 'forwards'
        }

        if (i == (text_array_slice.length - 1)) {
            timings_2.easing = `steps(${Number(single_word_len)}, end)`;
            let reveal_animation: any = document.querySelector(".text_hide")?.animate([
                { left: `${left_instance}%` },
                { left: `${left_instance + ((100 / text_len) * (word_len[i]))}%` }
            ], timings_2);

            document.querySelector(".text_cursor")?.animate([
                { left: `${left_instance}%` },
                { left: `${left_instance + ((100 / text_len) * (word_len[i]))}%` }
            ], timings_2);

            reveal_animation.onfinish = () => {
                setTimeout(() => {
                    document.querySelector('.text_hide')?.animate([
                        {left: '0%'}
                    ], {
                        duration: 2000,
                        easing: 'cubic-bezier(.73,0,.38,.88)'
                    });
                    document.querySelector('.text_cursor')?.animate([
                        {left: '0%'}
                    ], {
                        duration: 2000,
                        easing: 'cubic-bezier(.73,0,.38,.88)'
                    });
                    typing_animation();
                }, 1000);
            }
        } else {
            document.querySelector(".text_hide")?.animate([
                { left: `${left_instance}%` },
                { left: `${left_instance + ((100 / text_len) * (word_len[i] + 1))}%` }
            ], timings_2);

            document.querySelector(".text_cursor")?.animate([
                { left: `${left_instance}%` },
                { left: `${left_instance + ((100 / text_len) * (word_len[i] + 1))}%` }
            ], timings_2);
        }

        left_instance = left_instance + ((100 / text_len) * (word_len[i] + 1));
    }
}


// generate new guid (google unique identifire) string
export const generateGuid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {  
        var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);  
        return v.toString(16);  
     });
}

export const setRowSelection = (found: any): boolean => {
    if (found.isWrite || found.isRead || found.isUpdate || found.isDelete
      || found.isApprove || found.isReject || found.isActivate 
      || found.isDeactivate) {
      return true;
  }
  return false;
}

export function filterPermissions(arr: any[]) {
    return arr.map(obj => {
      return {
        ...obj,
        childMenus: obj.childMenus.filter((c: any) => c.rowSelected === true)
      };
    });
  }

export function enumToArray(value: object) {
    const result = [];
    const keys = Object.keys(value);
    const values = Object.values(value);
    for (let i = 0; i < keys.length; i++) {
      result.push(values[i]);
    }
    return result;
  }

  export const generateString = (length) => {
    const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let result = '';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
}

export function getParentHierarchy(data, menuId) {
  const startElement = data.find(item => item.menuId === menuId);

  if (!startElement) {
    return null;
  }

  const result = [];
  result.push(startElement);

  let parentId = startElement.parentId;
  while (parentId !== "null") {
    const parentElement = data.find(item => item.menuId === parentId);
    if (!parentElement) {
      break;
    }
    result.unshift(parentElement);
    parentId = parentElement.parentId;
  }

  return result;
}

export function getChildHierarchy(data, menuId) {
  const startElement = data.find(item => item.menuId === menuId);

  if (!startElement) {
    return null;
  }

  const result = [];
  // result.push(startElement);

  retrieveChildren(data, startElement.menuId, result);

  return result;
}

 function retrieveChildren(data, parentId, result) {
  const childElements = data.filter(item => item.parentId === parentId);
  if (childElements.length === 0) {
    return;
  }

  childElements.forEach(childElement => {
    result.push(childElement);
    retrieveChildren(data, childElement.menuId, result);
  });
}

export function getImmediateChildren(data, menuId) {
  const parentElement = data.find(item => item.menuId === menuId);

  if (!parentElement) {
    return null;
  }

  const childElements = data.filter(item => item.parentId === menuId);

  return childElements;
}

export const nationalities: any[] = [
    {
      country: "Peru",
      nationality: "Peruvian"
    },
    {
      country: "Brazil",
      nationality: "Brazilian"
    },
    {
      country: "Libya",
      nationality: "Libyan"
    },
    {
      country: "San Marino",
      nationality: "Sammarinese"
    },
    {
      country: "Thailand",
      nationality: "Thai"
    },
    {
      country: "Malaysia",
      nationality: "Malaysian"
    },
    {
      country: "Paraguay",
      nationality: "Paraguayan"
    },
    {
      country: "Namibia",
      nationality: "Namibian"
    },
    {
      country: "Slovakia",
      nationality: "Slovak"
    },
    {
      country: "China",
      nationality: "Chinese"
    },
    {
      country: "Honduras",
      nationality: "Honduran"
    },
    {
      country: "Uganda",
      nationality: "Ugandan"
    },
    {
      country: "Indonesia",
      nationality: "Indonesian"
    },
    {
      country: "South Georgia and the South Sandwich Islands",
      nationality: "South Georgia and the South Sandwich Islander"
    },
    {
      country: "Yemen",
      nationality: "Yemeni"
    },
    {
      country: "Azerbaijan",
      nationality: "Azerbaijani"
    },
    {
      country: "Israel",
      nationality: "Israeli"
    },
    {
      country: "Singapore",
      nationality: "Singaporean"
    },
    {
      country: "United Arab Emirates",
      nationality: "Emirati"
    },
    {
      country: "Bolivia (Plurinational State of)",
      nationality: "Bolivian"
    },
    {
      country: "Ireland",
      nationality: "Irish"
    },
    {
      country: "Central African Republic",
      nationality: "Central African"
    },
    {
      country: "French Polynesia",
      nationality: "French Polynesian"
    },
    {
      country: "Grenada",
      nationality: "Grenadian"
    },
    {
      country: "Guinea-Bissau",
      nationality: "Guinea-Bissauan"
    },
    {
      country: "Nepal",
      nationality: "Nepalese"
    },
    {
      country: "Panama",
      nationality: "Panamanian"
    },
    {
      country: "Burkina Faso",
      nationality: "Burkinabe"
    },
    {
      country: "Cambodia",
      nationality: "Cambodian"
    },
    {
      country: "Uzbekistan",
      nationality: "Uzbekistani"
    },
    {
      country: "Anguilla",
      nationality: "Anguillian"
    },
    {
      country: "Korea (Republic of)",
      nationality: "South Korean"
    },
    {
      country: "Curaçao",
      nationality: "Curaçaoan"
    },
    {
      country: "Wallis and Futuna",
      nationality: "Wallis and Futuna Islander"
    },
    {
      country: "Myanmar",
      nationality: "Burmese"
    },
    {
      country: "Egypt",
      nationality: "Egyptian"
    },
    {
      country: "Gambia",
      nationality: "Gambian"
    },
    {
      country: "Saudi Arabia",
      nationality: "Saudi Arabian"
    },
    {
      country: "Argentina",
      nationality: "Argentinean"
    },
    {
      country: "Canada",
      nationality: "Canadian"
    },
    {
      country: "Montenegro",
      nationality: "Montenegrin"
    },
    {
      country: "United States of America",
      nationality: "American"
    },
    {
      country: "Cook Islands",
      nationality: "Cook Islander"
    },
    {
      country: "Macao",
      nationality: "Macanese"
    },
    {
      country: "Cocos (Keeling) Islands",
      nationality: "Cocos Islander"
    },
    {
      country: "Saint Lucia",
      nationality: "Saint Lucian"
    },
    {
      country: "Cyprus",
      nationality: "Cypriot"
    },
    {
      country: "Iceland",
      nationality: "Icelander"
    },
    {
      country: "Côte d'Ivoire",
      nationality: "Ivorian"
    },
    {
      country: "Bangladesh",
      nationality: "Bangladeshi"
    },
    {
      country: "Bhutan",
      nationality: "Bhutanese"
    },
    {
      country: "Saint Kitts and Nevis",
      nationality: "Kittian and Nevisian"
    },
    {
      country: "Finland",
      nationality: "Finnish"
    },
    {
      country: "Macedonia (the former Yugoslav Republic of)",
      nationality: "Macedonian"
    },
    {
      country: "Qatar",
      nationality: "Qatari"
    },
    {
      country: "Sudan",
      nationality: "Sudanese"
    },
    {
      country: "Isle of Man",
      nationality: "Manx"
    },
    {
      country: "Latvia",
      nationality: "Latvian"
    },
    {
      country: "Timor-Leste",
      nationality: "East Timorese"
    },
    {
      country: "Sao Tome and Principe",
      nationality: "Sao Tomean"
    },
    {
      country: "Sweden",
      nationality: "Swedish"
    },
    {
      country: "Martinique",
      nationality: "Martinican"
    },
    {
      country: "Sierra Leone",
      nationality: "Sierra Leonean"
    },
    {
      country: "South Africa",
      nationality: "South African"
    },
    {
      country: "Tanzania, United Republic of",
      nationality: "Tanzanian"
    },
    {
      country: "Costa Rica",
      nationality: "Costa Rican"
    },
    {
      country: "Iran (Islamic Republic of)",
      nationality: "Iranian"
    },
    {
      country: "Dominican Republic",
      nationality: "Dominican"
    },
    {
      country: "Nigeria",
      nationality: "Nigerian"
    },
    {
      country: "Palestine, State of",
      nationality: "Palestinian"
    },
    {
      country: "Bosnia and Herzegovina",
      nationality: "Bosnian, Herzegovinian"
    },
    {
      country: "Cayman Islands",
      nationality: "Caymanian"
    },
    {
      country: "Maldives",
      nationality: "Maldivan"
    },
    {
      country: "Japan",
      nationality: "Japanese"
    },
    {
      country: "Chad",
      nationality: "Chadian"
    },
    {
      country: "Guinea",
      nationality: "Guinean"
    },
    {
      country: "Madagascar",
      nationality: "Malagasy"
    },
    {
      country: "Italy",
      nationality: "Italian"
    },
    {
      country: "Jordan",
      nationality: "Jordanian"
    },
    {
      country: "Liechtenstein",
      nationality: "Liechtensteiner"
    },
    {
      country: "Mongolia",
      nationality: "Mongolian"
    },
    {
      country: "Tonga",
      nationality: "Tongan"
    },
    {
      country: "Ecuador",
      nationality: "Ecuadorean"
    },
    {
      country: "Guam",
      nationality: "Guamanian"
    },
    {
      country: "Kuwait",
      nationality: "Kuwaiti"
    },
    {
      country: "Kyrgyzstan",
      nationality: "Kirghiz"
    },
    {
      country: "Mauritius",
      nationality: "Mauritian"
    },
    {
      country: "Åland Islands",
      nationality: "Ålandish"
    },
    {
      country: "Bahrain",
      nationality: "Bahraini"
    },
    {
      country: "Mexico",
      nationality: "Mexican"
    },
    {
      country: "Poland",
      nationality: "Polish"
    },
    {
      country: "Chile",
      nationality: "Chilean"
    },
    {
      country: "Djibouti",
      nationality: "Djibouti"
    },
    {
      country: "Ethiopia",
      nationality: "Ethiopian"
    },
    {
      country: "Mauritania",
      nationality: "Mauritanian"
    },
    {
      country: "Korea (Democratic People's Republic of)",
      nationality: "North Korean"
    },
    {
      country: "Swaziland",
      nationality: "Swazi"
    },
    {
      country: "Aruba",
      nationality: "Aruban"
    },
    {
      country: "Austria",
      nationality: "Austrian"
    },
    {
      country: "Haiti",
      nationality: "Haitian"
    },
    {
      country: "Portugal",
      nationality: "Portuguese"
    },
    {
      country: "Vanuatu",
      nationality: "Ni-Vanuatu"
    },
    {
      country: "Christmas Island",
      nationality: "Christmas Island"
    },
    {
      country: "Colombia",
      nationality: "Colombian"
    },
    {
      country: "Cuba",
      nationality: "Cuban"
    },
    {
      country: "French Guiana",
      nationality: "French Guianese"
    },
    {
      country: "Afghanistan",
      nationality: "Afghan"
    },
    {
      country: "Brunei Darussalam",
      nationality: "Bruneian"
    },
    {
      country: "Jamaica",
      nationality: "Jamaican"
    },
    {
      country: "Moldova (Republic of)",
      nationality: "Moldovan"
    },
    {
      country: "France",
      nationality: "French"
    },
    {
      country: "Kenya",
      nationality: "Kenyan"
    },
    {
      country: "Oman",
      nationality: "Omani"
    },
    {
      country: "Albania",
      nationality: "Albanian"
    },
    {
      country: "Cabo Verde",
      nationality: "Cape Verdian"
    },
    {
      country: "Turkey",
      nationality: "Turkish"
    },
    {
      country: "Zimbabwe",
      nationality: "Zimbabwean"
    },
    {
      country: "Algeria",
      nationality: "Algerian"
    },
    {
      country: "Niger",
      nationality: "Nigerien"
    },
    {
      country: "Hungary",
      nationality: "Hungarian"
    },
    {
      country: "Spain",
      nationality: "Spanish"
    },
    {
      country: "Germany",
      nationality: "German"
    },
    {
      country: "Guatemala",
      nationality: "Guatemalan"
    },
    {
      country: "Mozambique",
      nationality: "Mozambican"
    },
    {
      country: "Palau",
      nationality: "Palauan"
    },
    {
      country: "Lesotho",
      nationality: "Mosotho"
    },
    {
      country: "Marshall Islands",
      nationality: "Marshallese"
    },
    {
      country: "Suriname",
      nationality: "Surinamer"
    },
    {
      country: "Guyana",
      nationality: "Guyanese"
    },
    {
      country: "Sri Lanka",
      nationality: "Sri Lankan"
    },
    {
      country: "Lebanon",
      nationality: "Lebanese"
    },
    {
      country: "Mayotte",
      nationality: "Mahoran"
    },
    {
      country: "Samoa",
      nationality: "Samoan"
    },
    {
      country: "Solomon Islands",
      nationality: "Solomon Islander"
    },
    {
      country: "Denmark",
      nationality: "Danish"
    },
    {
      country: "Kiribati",
      nationality: "I-Kiribati"
    },
    {
      country: "Switzerland",
      nationality: "Swiss"
    },
    {
      country: "Lithuania",
      nationality: "Lithuanian"
    },
    {
      country: "Somalia",
      nationality: "Somali"
    },
    {
      country: "Norfolk Island",
      nationality: "Norfolk Islander"
    },
    {
      country: "Taiwan",
      nationality: "Taiwanese"
    },
    {
      country: "Ghana",
      nationality: "Ghanaian"
    },
    {
      country: "New Zealand",
      nationality: "New Zealander"
    },
    {
      country: "Senegal",
      nationality: "Senegalese"
    },
    {
      country: "Togo",
      nationality: "Togolese"
    },
    {
      country: "Zambia",
      nationality: "Zambian"
    },
    {
      country: "Belarus",
      nationality: "Belarusian"
    },
    {
      country: "Saint Vincent and the Grenadines",
      nationality: "Saint Vincentian"
    },
    {
      country: "El Salvador",
      nationality: "Salvadoran"
    },
    {
      country: "Norway",
      nationality: "Norwegian"
    },
    {
      country: "Malta",
      nationality: "Maltese"
    },
    {
      country: "Nicaragua",
      nationality: "Nicaraguan"
    },
    {
      country: "Australia",
      nationality: "Australian"
    },
    {
      country: "Luxembourg",
      nationality: "Luxembourger"
    },
    {
      country: "Pakistan",
      nationality: "Pakistani"
    },
    {
      country: "Saint Helena, Ascension and Tristan da Cunha",
      nationality: "Saint Helenian"
    },
    {
      country: "Turks and Caicos Islands",
      nationality: "Turks and Caicos Islander"
    },
    {
      country: "Western Sahara",
      nationality: "Sahrawi"
    },
    {
      country: "Belgium",
      nationality: "Belgian"
    },
    {
      country: "Eritrea",
      nationality: "Eritrean"
    },
    {
      country: "Seychelles",
      nationality: "Seychellois"
    },
    {
      country: "Antigua and Barbuda",
      nationality: "Antiguan, Barbudan"
    },
    {
      country: "Liberia",
      nationality: "Liberian"
    },
    {
      country: "Tuvalu",
      nationality: "Tuvaluan"
    },
    {
      country: "Bermuda",
      nationality: "Bermudian"
    },
    {
      country: "Cameroon",
      nationality: "Cameroonian"
    },
    {
      country: "Saint Pierre and Miquelon",
      nationality: "Saint-Pierrais"
    },
    {
      country: "Ukraine",
      nationality: "Ukrainian"
    },
    {
      country: "Georgia",
      nationality: "Georgian"
    },
    {
      country: "Netherlands",
      nationality: "Dutch"
    },
    {
      country: "Mali",
      nationality: "Malian"
    },
    {
      country: "Niue",
      nationality: "Niuean"
    },
    {
      country: "Puerto Rico",
      nationality: "Puerto Rican"
    },
    {
      country: "United Kingdom of Great Britain and Northern Ireland",
      nationality: "British"
    },
    {
      country: "Armenia",
      nationality: "Armenian"
    },
    {
      country: "Greenland",
      nationality: "Greenlandic"
    },
    {
      country: "Kazakhstan",
      nationality: "Kazakhstani"
    },
    {
      country: "Réunion",
      nationality: "Réunionese"
    },
    {
      country: "Saint Martin (French part)",
      nationality: "Saint Martin Islander"
    },
    {
      country: "Belize",
      nationality: "Belizean"
    },
    {
      country: "Greece",
      nationality: "Greek"
    },
    {
      country: "Trinidad and Tobago",
      nationality: "Trinidadian"
    },
    {
      country: "Benin",
      nationality: "Beninese"
    },
    {
      country: "Tajikistan",
      nationality: "Tadzhik"
    },
    {
      country: "Czech Republic",
      nationality: "Czech"
    },
    {
      country: "India",
      nationality: "Indian"
    },
    {
      country: "Lao People's Democratic Republic",
      nationality: "Laotian"
    },
    {
      country: "Syrian Arab Republic",
      nationality: "Syrian"
    },
    {
      country: "Turkmenistan",
      nationality: "Turkmen"
    },
    {
      country: "Botswana",
      nationality: "Motswana"
    },
    {
      country: "Virgin Islands (British)",
      nationality: "Virgin Islander (British)"
    },
    {
      country: "American Samoa",
      nationality: "American Samoan"
    },
    {
      country: "Guadeloupe",
      nationality: "Guadeloupian"
    },
    {
      country: "New Caledonia",
      nationality: "New Caledonian"
    },
    {
      country: "Viet Nam",
      nationality: "Vietnamese"
    },
    {
      country: "Comoros",
      nationality: "Comoran"
    },
    {
      country: "Micronesia (Federated States of)",
      nationality: "Micronesian"
    },
    {
      country: "Burundi",
      nationality: "Burundian"
    },
    {
      country: "Morocco",
      nationality: "Moroccan"
    },
    {
      country: "Saint Barthélemy",
      nationality: "Saint Barthélemy Islander"
    },
    {
      country: "Barbados",
      nationality: "Barbadian"
    },
    {
      country: "Virgin Islands (U.S.)",
      nationality: "Virgin Islander (U.S.)"
    },
    {
      country: "Iraq",
      nationality: "Iraqi"
    },
    {
      country: "Papua New Guinea",
      nationality: "Papua New Guinean"
    },
    {
      country: "Equatorial Guinea",
      nationality: "Equatorial Guinean"
    },
    {
      country: "Gabon",
      nationality: "Gabonese"
    },
    {
      country: "Uruguay",
      nationality: "Uruguayan"
    },
    {
      country: "Monaco",
      nationality: "Monegasque"
    },
    {
      country: "Tunisia",
      nationality: "Tunisian"
    },
    {
      country: "Fiji",
      nationality: "Fijian"
    },
    {
      country: "Rwanda",
      nationality: "Rwandan"
    },
    {
      country: "Angola",
      nationality: "Angolan"
    },
    {
      country: "Falkland Islands (Malvinas)",
      nationality: "Falkland Islander"
    },
    {
      country: "Serbia",
      nationality: "Serbian"
    },
    {
      country: "Slovenia",
      nationality: "Slovenian"
    },
    {
      country: "Congo (Democratic Republic of the)",
      nationality: "Congolese (Democratic Republic)"
    },
    {
      country: "Malawi",
      nationality: "Malawian"
    },
    {
      country: "Venezuela (Bolivarian Republic of)",
      nationality: "Venezuelan"
    },
    {
      country: "Bulgaria",
      nationality: "Bulgarian"
    },
    {
      country: "Hong Kong",
      nationality: "Hong Kongese"
    },
    {
      country: "Gibraltar",
      nationality: "Gibraltar"
    },
    {
      country: "South Sudan",
      nationality: "South Sudanese"
    },
    {
      country: "Nauru",
      nationality: "Nauruan"
    },
    {
      country: "Pitcairn",
      nationality: "Pitcairn Islander"
    },
    {
      country: "Russian Federation",
      nationality: "Russian"
    },
    {
      country: "Andorra",
      nationality: "Andorran"
    },
    {
      country: "Faroe Islands",
      nationality: "Faroese"
    },
    {
      country: "Congo",
      nationality: "Congolese"
    },
    {
      country: "Croatia",
      nationality: "Croatian"
    },
    {
      country: "Montserrat",
      nationality: "Montserratian"
    },
    {
      country: "Philippines",
      nationality: "Filipino"
    },
    {
      country: "Republic of Kosovo",
      nationality: "Kosovar"
    },
    {
      country: "Romania",
      nationality: "Romanian"
    },
    {
      country: "Tokelau",
      nationality: "Tokelauan"
    },
    {
      country: "Bahamas",
      nationality: "Bahamian"
    },
    {
      country: "Estonia",
      nationality: "Estonian"
    }
  ];